import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

export const MessageVipForeignView: FC = () => (
  <FormattedMessage
    id="profile.vip.present.foreign.user.gift"
    defaultMessage="Продлите VIP-статус и здесь будет отображаться ваше фото."
  />
)
